import type { StatusValue } from '@atlassian/jira-issue-field-status/src/common/types.tsx';
import type { IssueStatusCell$data } from '@atlassian/jira-relay/src/__generated__/IssueStatusCell.graphql';

export type JiraStatusField = IssueStatusCell$data['status'];

export const toJiraStatusField = (statusValue: StatusValue): JiraStatusField => ({
	statusId: statusValue.id,
	name: statusValue.name,
	statusCategory: {
		statusCategoryId: `${statusValue.statusCategory.id}`,
	},
});

export const toStatusValue = (jiraStatusField: JiraStatusField): StatusValue => ({
	id: jiraStatusField.statusId,
	name: jiraStatusField.name ?? '',
	statusCategory: {
		id: parseInt(jiraStatusField.statusCategory?.statusCategoryId ?? '', 10),
	},
});
